import React, {useEffect} from 'react';
import Lottie from 'lottie-react-native';
import {cpf} from 'cpf-cnpj-validator';

import {Container, Content, Description, Header, Title} from './styles';

import {api, apiMasterClin} from '../../../services/api';
import {useNavigation, useRoute} from '@react-navigation/native';
import {useAuth} from '../../../context/auth';
import {ClubeDTO} from '../../../dtos/ClubeDTO';

interface Params {
  callback?: () => void;
}

export function LoadingClube() {
  const navigation = useNavigation();
  const {user} = useAuth();
  const animationSource = _WEB_
    ? null
    : require('../../../assets/images/json/animation_lm7tacm9.json');

  const route = useRoute();

  let callback: (() => void) | undefined;

  if (route.params) {
    const {callback: callbackFuncion} = route.params as Params;

    callback = callbackFuncion;
  }

  function formatPhone(phone: string) {
    const digits = (phone || '').replace(/\D/g, '');

    if (digits.length === 11) {
      return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
    }

    if (digits.length === 10) {
      return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`;
    }

    return phone;
  }

  async function renovaBeneficiarioMasterclin(validade: string, id: string) {
    const vencimentoCartao =
      new Date(validade).getFullYear() +
      '-' +
      (new Date(validade).getMonth() + 1).toString().padStart(2, '0') +
      '-' +
      (new Date(validade).getDate() + 1);

    await apiMasterClin
      .put('/beneficiarios/' + id, {
        ativo: true,
        nome: user.name,
        cpf: cpf.format(user.cpf),
        cartao: {
          validade: vencimentoCartao,
        },
      })
      .then(() => {
        renovaBeneficiario(validade);
      })
      .catch(({response}) => {
        if (response.data.error) {
          navigation.navigate('ConfirmationScreen', {
            type: 'error',
            buttonAction: () => navigation.navigate('Initial'),
            buttonText: 'Ir para a tela inicial',
            closeIconAction: () => navigation.navigate('Initial'),
            text: response.data.error,
            title: 'Ocorreu um problema',
          });
        } else {
          navigation.navigate('ConfirmationScreen', {
            type: 'error',
            buttonAction: () => navigation.navigate('Initial'),
            buttonText: 'Ir para a tela inicial',
            closeIconAction: () => navigation.navigate('Initial'),
            text: 'Ocorreu um erro no processamento. Entre em contato com nosso suporte para obter ajuda.',
            title: 'Ocorreu um problema',
          });
        }
      });
  }

  async function cadastraBeneficiarioMasterclin(validade: string) {
    const vencimentoCartao =
      new Date(validade).getFullYear() +
      '-' +
      (new Date(validade).getMonth() + 1).toString().padStart(2, '0') +
      '-' +
      (new Date(validade).getDate() + 1);

    await apiMasterClin
      .post('/beneficiarios', {
        ativo: true,
        usuario: {
          email: user.email,
          senha: user.cpf,
        },
        cartao: {
          validade: vencimentoCartao,
        },
        nome: user.name,
        cpf: cpf.format(user.cpf),
        telefone: {
          celular: formatPhone(user.phone),
        },
      })
      .then(response => {
        cadastraBeneficiario(response.data);
      })
      .catch(({response}) => {
        if (response.data.error) {
          navigation.navigate('ConfirmationScreen', {
            type: 'error',
            buttonAction: () => navigation.navigate('Initial'),
            buttonText: 'Ir para a tela inicial',
            closeIconAction: () => navigation.navigate('Initial'),
            text: response.data.error,
            title: 'Ocorreu um problema',
          });
        } else {
          navigation.navigate('ConfirmationScreen', {
            type: 'error',
            buttonAction: () => navigation.navigate('Initial'),
            buttonText: 'Ir para a tela inicial',
            closeIconAction: () => navigation.navigate('Initial'),
            text: 'Ocorreu um erro no processamento. Entre em contato com nosso suporte para obter ajuda.',
            title: 'Ocorreu um problema',
          });
        }
      });
  }

  async function renovaBeneficiario(validade: string) {
    await api
      .post('/renovaMasterclin', {
        cartao: {
          validade: validade,
        },
      })
      .then(response => {
        if (callback) {
          callback();
        } else {
          navigation.navigate('Clube', {
            id_masterclin: response.data.id_masterclin,
          });
        }
      })
      .catch(({response}) => {
        if (response.data.error) {
          navigation.navigate('ConfirmationScreen', {
            type: 'error',
            buttonAction: () => navigation.navigate('Initial'),
            buttonText: 'Ir para a tela inicial',
            closeIconAction: () => navigation.navigate('Initial'),
            text: response.data.error,
            title: 'Ocorreu um problema',
          });
        } else {
          navigation.navigate('ConfirmationScreen', {
            type: 'error',
            buttonAction: () => navigation.navigate('Initial'),
            buttonText: 'Ir para a tela inicial',
            closeIconAction: () => navigation.navigate('Initial'),
            text: 'Ocorreu um erro no processamento. Entre em contato com nosso suporte para obter ajuda.',
            title: 'Ocorreu um problema',
          });
        }
      });
  }

  async function cadastraBeneficiario(data: ClubeDTO) {
    await api
      .post('/gravaMasterclin', data)
      .then(response => {
        if (callback) {
          callback();
        } else {
          navigation.navigate('Clube', {
            id_masterclin: response.data.id_masterclin,
          });
        }
      })
      .catch(({response}) => {
        if (response.data.error) {
          navigation.navigate('ConfirmationScreen', {
            type: 'error',
            buttonAction: () => navigation.navigate('Initial'),
            buttonText: 'Ir para a tela inicial',
            closeIconAction: () => navigation.navigate('Initial'),
            text: response.data.error,
            title: 'Ocorreu um problema',
          });
        } else {
          navigation.navigate('ConfirmationScreen', {
            type: 'error',
            buttonAction: () => navigation.navigate('Initial'),
            buttonText: 'Ir para a tela inicial',
            closeIconAction: () => navigation.navigate('Initial'),
            text: 'Ocorreu um erro no processamento. Entre em contato com nosso suporte para obter ajuda.',
            title: 'Ocorreu um problema',
          });
        }
      });
  }

  async function verificaMasterclin() {
    await api
      .get('/verificaMasterclin')
      .then(response => {
        const {validade, idMasterclin, status} = response.data;

        if (status === 'Renovação') {
          renovaBeneficiarioMasterclin(validade, idMasterclin);
        }

        if (status === 'Criação') {
          cadastraBeneficiarioMasterclin(validade);
        }
      })
      .catch(({response}) => {
        if (response.data.error) {
          navigation.navigate('ClubeNotEligible', {
            message: response.data.error,
          });
        } else {
          navigation.navigate('ConfirmationScreen', {
            type: 'error',
            buttonAction: () => navigation.navigate('Initial'),
            buttonText: 'Ir para a tela inicial',
            closeIconAction: () => navigation.navigate('Initial'),
            text: 'Ocorreu um erro no processamento. Entre em contato com nosso suporte para obter ajuda.',
            title: 'Ocorreu um problema',
          });
        }
      });
  }

  useEffect(() => {
    async function acessaMasterclin() {
      await api
        .get('/acessaMasterclin')
        .then(response => {
          if (response.data) {
            if (callback) {
              callback();
            } else {
              navigation.navigate('Clube', {
                id_masterclin: response.data.id_masterclin,
              });
            }
          }
        })
        .catch(({response}) => {
          if (
            response.data.error === 'Usuário não encontrado. Efetue a criação.'
          ) {
            return verificaMasterclin();
          }
          if (response.data.error === 'Usuário inativo. Efetue a renovação.') {
            return verificaMasterclin();
          }

          if (response.data.error === 'Cartão expirado. Efetue a renovação.') {
            return verificaMasterclin();
          }

          if (response.data.error) {
            return navigation.navigate('ClubeNotEligible', {
              message: response.data.error,
            });
          }

          return navigation.navigate('ConfirmationScreen', {
            type: 'error',
            buttonAction: () => navigation.navigate('Initial'),
            buttonText: 'Ir para a tela inicial',
            closeIconAction: () => navigation.navigate('Initial'),
            text: 'Ocorreu um erro no processamento. Entre em contato com nosso suporte para obter ajuda.',
            title: 'Ocorreu um problema',
          });
        });
    }

    acessaMasterclin();
  }, []);

  return (
    <Container>
      <Header>
        {animationSource && (
          <Lottie
            source={animationSource}
            autoPlay
            loop
            style={{
              width: '55%',
              height: '55%',
            }}
            resizeMode="cover"
          />
        )}
      </Header>
      <Content>
        <Title>Carregando informações</Title>
        <Description>Por favor, aguarde alguns instantes.</Description>
      </Content>
    </Container>
  );
}
